<div class="mb-4">
  <h5 class="text-[20px] text-heading font-bold mb-1 leading-none">Reimbursement</h5>
  <ul>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.dashboard">Home</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.disbursementNavigator">Disbursement</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] font-semibold font-normal inline-block mr-2">
      Reimbursement
    </li>
  </ul>
</div>

<div class="bg-white p-4 mb-10">
  <div [formGroup]="fgReimFilter" class="grid grid-cols-12 gap-x-4">
    <div class="col-span-6">
      <div class="text-xl font-semibold mb-4">Reimbursement</div>
    </div>
    <div class="col-span-6">
      <div class="mb-4 flex-end">
        <button (click)="newReim()" class="custom-button custom-button-primary">
          <i class="fal fa-file-import mr-2"></i> New Request
        </button>
      </div>
    </div>
    <div class="col-span-12 md:col-span-4">
      <div class="mb-4">
        <mat-select [formControl]="fgReimFilter.controls.Type" class="form-control">
          <mat-option value="My Requests">My Requests</mat-option>
          <mat-option value="For My Approval">For My Approval</mat-option>
          <mat-option value="All Requests">All Requests</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="col-span-12 md:col-span-4">
      <div class="mb-4">
        <mat-select [formControl]="fgReimFilter.controls.Status" class="form-control">
          <mat-option *ngFor="let status of reimApprovalStatuses$|async"
            [value]="status.Status">{{status.Status}}</mat-option>
          <mat-option value="All Status">All Status</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="col-span-12 md:col-span-4"></div>
  </div>

  <app-acc-table [pagination]="pagination" [haveSpaceBetweenLimitAndSearch]="false">
    <table class="custom-table custom-table-default custom-table-border-row">
      <thead class="text-xs uppercase">
        <tr *ngIf="waitHandler.processing"></tr>
        <tr *ngIf="!waitHandler.processing" class="relaive">
          <th>Control Number</th>
          <th>Request Status</th>
          <th>Voucher Number</th>
          <th>Purpose</th>
          <th>Total Ammount</th>
          <th>Approved Ammount</th>
          <th>Description</th>
          <th>Remarks</th>
          <th>Request Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="waitHandler.processing">
          <td colspan="999">
            <app-acc-loader></app-acc-loader>
          </td>
        </tr>
        <ng-container *ngIf="!waitHandler.processing">
          <ng-container *ngIf="reimList$|async as reimbursementList">
            <tr *ngIf="!reimbursementList.length">
              <td colspan="999" class="bg-white sticky left-0">
                <div class="flex gap-2">
                  No Data found...
                  <div *ngIf="pagination.query" class="text-slate-500">
                    Can't find what your looking for?
                    <a (click)="dialogs.openSearch()" href="javascript:void(0);" class="text-blue-400 underline">
                      Search tips
                    </a>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngFor="let item of reimbursementList">
              <td class="whitespace-nowrap">
                <a [routerLink]="[routes.reimbursement, item.CntrlNumber]" class="whitespace-nowrap">
                  <i class="fa-light fa-receipt text-md"></i>
                  -
                  <span class="underline text-red-500">
                    {{item.CntrlNumber||''}}
                  </span>
                </a>
              </td>
              <td class="whitespace-nowrap">
                <span class="badge badge-default whitespace-nowrap">
                  {{item.Status||'No Status'}}
                </span>

                <ng-container [ngSwitch]="item.RequestStatus">
                  <span *ngSwitchCase="'Approved'" class="badge badge-green whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Disapproved'" class="badge badge-red whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Pending'" class="badge badge-yellow whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchDefault class="badge badge-dark whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                </ng-container>
              </td>
              <td class="whitespace-nowrap">
                <span *ngIf="item.Voucher as voucher">
                  <i class="fa-light fa-money-check-dollar text-md"></i>
                  {{voucher.Info.VoucherNumber}}
                </span>
              </td>
              <td class="whitespace-nowrap">
                <span class="whitespace-nowrap">{{item.Purpose||''}}</span>
              </td>
              <td class="whitespace-nowrap">{{item.OverallTotalAmount|currency:'₱ '}} </td>
              <td class="whitespace-nowrap font-bold text-red-400">{{item.OverallApprovedAmount|currency:'₱ '}} </td>
              <td class="whitespace-nowrap">{{(item.Description||'')|strLimit:50}} </td>
              <td class="whitespace-nowrap">{{(item.Remarks||'')|strLimit:50}} </td>
              <td class="whitespace-nowrap">{{item.created_at}} </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </app-acc-table>
</div>